import React from 'react';
import {Button, Link, List, Progress} from 'components';
import {map, sortBy, sumBy, useSelector} from 'helpers';
import questions from './questions.json';
import css from './score.module.scss';

export function Score() {
  const { quiz } = useSelector(state => state.session);

  let results = map(questions, ({ name, title }) => ({
    id: title,
    title,
    score: parseInt(quiz['quiz-'+name] || '0'),
  }));
  results = sortBy(results, 'score').reverse();

  const total = sumBy(results, 'score');
  const max = results.length*5;
  const top = results.slice(0, 3);
  const bottom = results.slice(-3);

  return (
    <div className="text-center">
      <div className={css.progress}>
        <Progress total={max} completed={total} label={total} semicircle />
      </div>
      <div className="medium-spacing text-left">
        <b>Success Contributors</b>
        <List className="small-spacing secondary" bordered>
          { top.map(result =>
            <p key={ result.id }>{ result.title }</p>
          ) }
        </List>
      </div>
      <div className="spacing text-left">
        <b>Areas to focus on</b>
        <List className="small-spacing secondary" bordered>
          { bottom.map(result =>
            <p key={ result.id }>{ result.title }</p>
          ) }
        </List>
      </div>
      <p className="medium-spacing">
        <Button to="/" className="primary">Complete</Button>
      </p>
      <p>
        <Link to="../quiz/intro/" className="link">Start Over</Link>
      </p>
    </div>
  );
}
